exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._15HjS{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-flow:wrap;flex-flow:wrap;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin:6px 0 0;text-transform:uppercase}._3U-2S{margin:0;padding:0;width:340px}._3U-2S li{background-color:#f7f7f7;color:#878787;display:block;list-style:none;padding:0 5px;position:relative;margin:0 0 2px;-webkit-transition:.25s;-o-transition:.25s;transition:.25s}@media (max-width:768px){._15HjS{margin:2px 0 0}._3U-2S{width:100%}._3U-2S li{margin:0 0 2px}}._3U-2S li.w35P5{background-color:#002f66;color:#fff}._3U-2S li.w35P5 ._3XTsm{color:#fff}._3U-2S li:hover{background-color:#002f66}._3XTsm{display:block;padding:20px;text-decoration:none;font-size:15.2px;font-size:.95rem;font-weight:300}._3XTsm,._3XTsm:active,._3XTsm:visited{color:#002f66}._3U-2S li.w35P5 ._3XTsm:hover,._3XTsm:hover{color:#ddd}", ""]);

// exports
exports.locals = {
	"root": "_15HjS",
	"menu": "_3U-2S",
	"current": "w35P5",
	"link": "_3XTsm"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Sidebar/Sidebar.css
// module id = 752
// module chunks = 1 2